// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__ADp39","resendInfoText":"OnGoingPaymentBox_resendInfoText__2HqzJ"};